import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Link, navigate } from 'gatsby'
import cn from 'classnames'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import Button from '~components/Button'
import S from '~components/seo'

import useOAuthSignOut from '~hooks/useOAuthSignOut'
import { UserContext, initialState } from '~context/provider'
import Footer from '~components/Footer'
import xcadLogo from '~img/new-xcad-logo.svg'
import * as s from './RegisterLayout.module.scss'

const RegisterLayout = ({ children, title }) => {
  const { t } = useTranslation()
  const { user, setUser } = useContext(UserContext)
  const { signOut } = useOAuthSignOut()

  const [firstPart, secondPart] = title.split('<span>')
  const [spanContent, thirdPart] = secondPart.split('</span>')
  const isAuthenticated = user && user.accessToken

  const links = [
    { href: '/dashboard', text: t('dashboard') },
    { href: '/dashboard', text: t('wallet') },
  ]

  const handleClick = () => {
    setUser(initialState)
    signOut()
    navigate('/register')
  }

  return (
    <div className={s.mainContainer}>
      <S title="Register" />
      <div
        className={cn(s.headerWrapper, {
          [s.withTitle]: title !== '<span></span>',
        })}
      >
        <div className={cn(s.nav, isAuthenticated ? s.withUser : s.noUser)}>
          <div className={s.navlinks}>
            <Link to="/buy" rel="nofollow">
              <img src={xcadLogo} height={45} alt="xcad logo" />
            </Link>
            {isAuthenticated &&
              links.map((link) => (
                <a
                  rel="nofollow"
                  key={link.href}
                  href={link.href}
                  onClick={() => navigate(link.text.toLowerCase())}
                >
                  {link.text}
                </a>
              ))}
          </div>
          <div className={s.btnContainer}>
            {isAuthenticated && (
              <Button
                title={t('buy')}
                variant="filled"
                size="md"
                onClick={() => navigate('/buy-tokens')}
              />
            )}
            <Button
              title={t('signOut')}
              variant="outlined"
              size="md"
              className={cn({ [s.noUserButton]: !isAuthenticated })}
              onClick={handleClick}
            />
          </div>
        </div>
        <h2 className={s.signTitle}>
          {firstPart} <span>{spanContent}</span> {thirdPart}
        </h2>
        <div />
      </div>
      {children}
      <Footer />
    </div>
  )
}

RegisterLayout.defaultProps = {
  children: null,
  title: 'Create your XCAD Account and<span>Buy XCAD!</span>',
}

RegisterLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
}

export default RegisterLayout
